import { closeCurrentTask } from './close-current-task/close-current-task.tsx';
import { setOpenTaskId } from './set-open-task-id/set-open-task-id.tsx';
import { refreshAppState } from './refresh-app-state/refresh-app-state.tsx';
import { completeTask } from './complete-task/complete-task.tsx';
import { completeTaskAndContinue } from './complete-task-and-continue/complete-task-and-continue.tsx';
import { setQuickstartBannerVisibility } from './set-quickstart-banner-visibility/set-quickstart-banner-visibility.tsx';
import { setSpotlightStepId } from './set-spotlight-step-id/set-spotlight-step-id.tsx';
import { addMountedSpotlight } from './add-mounted-spotlight/add-mounted-spotlight.tsx';
import { removeMountedSpotlight } from './remove-mounted-spotlight/remove-mounted-spotlight.tsx';
import { closeCurrentSpotlightStep } from './close-current-spotlight-step/close-current-spotlight-step.tsx';
import { setEventHandler } from './set-event-handler/set-event-handler.tsx';
import { openDeliveryTab } from './open-delivery-tab/open-delivery-tab.tsx';
import { navigateToAllIdeas } from './navigate-to-all-ideas/navigate-all-ideas.tsx';

export const actions = {
	setOpenTaskId,
	closeCurrentTask,
	refreshAppState,
	completeTask,
	openDeliveryTab,
	completeTaskAndContinue,
	setQuickstartBannerVisibility,
	setSpotlightStepId,
	closeCurrentSpotlightStep,
	addMountedSpotlight,
	removeMountedSpotlight,
	setEventHandler,
	navigateToAllIdeas,
};
